module.exports = __webpack_public_path__ + "static/media/financehead.c9e37907.jpg";